"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _music = _interopRequireDefault(require("cccisd-icons/music"));
var _music2 = _interopRequireDefault(require("./music.svg"));
var _cccisdLaravelResources = require("cccisd-laravel-resources");
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Audio = /*#__PURE__*/function (_React$Component) {
  function Audio() {
    var _this;
    _classCallCheck(this, Audio);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Audio, [].concat(args));
    _defineProperty(_this, "onSelect", function (selectedFile) {
      var id = selectedFile.id,
        url = selectedFile.url,
        name = selectedFile.name;
      _this.props.setContent(_this.props.content, _objectSpread(_objectSpread({}, (0, _omit2["default"])(_this.props.meta, 'tts')), {}, {
        audio: {
          id: id,
          resourceId: id,
          audioFileName: name,
          url: url,
          isAsset: true,
          transcript: _this.props.content
        }
      }));
    });
    _defineProperty(_this, "unattachAudio", function () {
      _this.props.setContent(_this.props.content, (0, _omit2["default"])(_this.props.meta, ['audio', 'tts']));
    });
    _defineProperty(_this, "getSelectedAudio", function () {
      var meta = _this.props.meta;
      return meta.audio ? {
        initialSelectedFile: Number(meta.audio.resourceId)
      } : {};
    });
    return _this;
  }
  _inherits(Audio, _React$Component);
  return _createClass(Audio, [{
    key: "render",
    value: function render() {
      var _this2 = this,
        _this$context$flow;
      return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelResources.AssetPicker, _extends({
        globalFilter: "audio",
        render: function render(_ref) {
          var body = _ref.body,
            selectedFile = _ref.selectedFile;
          return /*#__PURE__*/_react["default"].createElement("div", null, body, /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].buttons
          }, /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-primary",
            disabled: !selectedFile,
            onClick: _this2.onSelect.bind(_this2, selectedFile)
          }, "Select audio"), _this2.props.meta.audio && /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-warning",
            onClick: _this2.unattachAudio
          }, "Unattach current audio")));
        },
        extra: {
          allowTts: (_this$context$flow = this.context.flow) === null || _this$context$flow === void 0 ? void 0 : _this$context$flow.allowTts,
          ttsContent: this.props.content
        }
      }, this.getSelectedAudio()));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Audio, "propTypes", {
  insertContent: _propTypes["default"].func,
  content: _propTypes["default"].string,
  meta: _propTypes["default"].object,
  setContent: _propTypes["default"].func,
  selectedContent: _propTypes["default"].string
});
_defineProperty(Audio, "contextTypes", {
  flow: _propTypes["default"].object
});
var addIcon = function addIcon(content) {
  var _content$meta;
  var icons = [];
  if (content !== null && content !== void 0 && (_content$meta = content.meta) !== null && _content$meta !== void 0 && _content$meta.audio) {
    if (content.meta.audio.resourceId) {
      icons.push(/*#__PURE__*/_react["default"].createElement("i", {
        title: "with audio"
      }, /*#__PURE__*/_react["default"].createElement(_music["default"], null)));
    }
  }
  return icons.length > 0 ? icons : false;
};
var _default = exports["default"] = {
  name: 'cccisdAudio',
  tooltip: 'Add Audio',
  image: _music2["default"],
  title: 'Add Audio',
  component: Audio,
  modalSize: '90%',
  addIcon: addIcon
};